<template>
  <div class="filters">
    <FormGroup :label="$t('planification.filters.group-name.label')">
      <Input v-model="groupName" />
    </FormGroup>
  </div>
</template>

<script>
export default {
  computed: {
    groupName: {
      get() {
        return this.$store.state.planification.sort.groupName;
      },
      set(groupName) {
        this.$store.commit('planification/setSortGroupName', groupName);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.filters {
  display: grid;
  grid-template-columns: 300px auto;
}
</style>
